import React from 'react';
import { FormField, InputAdornmentButton, NumberInput, TDeviceType } from '@cian/ui-kit';
import { IconActionMinus12, IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as styles from './styles.css';

export type NumberInputSize = React.ComponentProps<typeof NumberInput>['size'];

export interface IRateNumberInputProps {
  value: number;
  isMin: boolean;
  isMax: boolean;
  label: string;
  device: TDeviceType;
  onDecrement: () => void;
  onIncrement: () => void;
  onSetMax?: () => void;
  setMaxButtonLabel?: string;
  size?: NumberInputSize;
  width?: number;
}

const DEFAULT_SET_MAX_LABEL = 'Обойти всех конкурентов';

export const RateNumberInput: React.FC<IRateNumberInputProps> = ({
  value,
  isMin,
  isMax,
  label,
  device,
  onDecrement,
  onIncrement,
  onSetMax,
  setMaxButtonLabel = DEFAULT_SET_MAX_LABEL,
  size = 'M',
}) => {
  const showSetMaxButton = onSetMax !== undefined;

  const rightAdornment = (
    <div className={clsx(styles['increment'], !showSetMaxButton && styles['increment-width'], styles[device])}>
      <InputAdornmentButton onClick={onIncrement} disabled={isMax}>
        <IconActionPlus16 color={isMax ? 'icon-secondary-default' : 'icon-main-default'} />
      </InputAdornmentButton>
      {showSetMaxButton && (
        <button
          type="button"
          className={clsx(styles['set-max-button'], isMax && styles['set-max-button-disabled'])}
          onClick={onSetMax}
          disabled={isMax}
        >
          {setMaxButtonLabel}
        </button>
      )}
    </div>
  );

  return (
    <FormField label={label}>
      <NumberInput
        size={size}
        textAlign="center"
        value={value}
        readOnly
        rightAdornment={rightAdornment}
        leftAdornment={
          <InputAdornmentButton onClick={onDecrement} disabled={isMin}>
            <IconActionMinus12 color={isMin ? 'icon-secondary-default' : 'icon-main-default'} />
          </InputAdornmentButton>
        }
      />
    </FormField>
  );
};
